import styled from '@emotion/styled';

const Tabs = styled('div', {
  label: 'Tabs',
})<{ tabIndex: number }>`
  position: relative;
  width: 100%;
  height: 1.95rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 1rem;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: calc(1 / 3 * 100%);
    height: 0.15rem;
    background-color: #1f2d49;
    left: ${({ tabIndex }) => (tabIndex / 3) * 100}%;
    transition: left 0.25s ease-out;
  }
`;

export default Tabs;
